import { useState } from "react";

import { IUser, TableParams } from "../../../../types";
import { isEmail } from "../../../../utils";
import { ContentWrapper } from "../../../common/styledComponents";
import useEmailParam from "../../../hooks/useEmailParam";
import UserFilters, { UserFilterOptions } from "../Common/UserFilters";
import { CreateUser } from "./CreateUser";
import UserList from "./UserList";
import { HeaderRow } from "./styles";

const ActivationView = () => {
  const [emailParam, setEmailParam] = useEmailParam();
  const [searchParam, setSearchParam] = useState<string | null | undefined>(
    emailParam
  );
  const [filterOptions, setFilterOptions] = useState<UserFilterOptions>({
    search: searchParam || "",
    all: false,
  });

  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  const handleCreateUser = (newUser: IUser) => {
    // First set email param to ensure it's stored for highlighting
    setEmailParam(newUser.email);
    setSearchParam(newUser.email);

    // Update filter options to search for the new user
    setFilterOptions({
      ...filterOptions,
      search: newUser.email,
      all: false,
    });

    // Reset pagination to first page to ensure the user is visible
    setTableParams((prev: TableParams) => ({
      ...prev,
      pagination: { ...prev.pagination, current: 1 },
    }));
  };

  return (
    <ContentWrapper>
      <HeaderRow>
        <UserFilters
          filterOptions={filterOptions}
          setFilterOptions={(
            updatedFilterOptions: Partial<UserFilterOptions>
          ) => {
            if (!updatedFilterOptions.all) {
              setSearchParam(updatedFilterOptions.search);
              isEmail(updatedFilterOptions.search || "")
                ? setEmailParam(updatedFilterOptions.search)
                : setEmailParam(undefined);
            }
            setFilterOptions({
              ...filterOptions,
              ...updatedFilterOptions,
            });
            setTableParams({
              ...tableParams,
              pagination: {
                ...tableParams.pagination,
                current: 1,
              },
            });
          }}
        />
        <CreateUser onCreateUser={handleCreateUser} />
      </HeaderRow>
      <UserList
        filterOptions={filterOptions}
        setEmailParam={setEmailParam}
        tableParams={tableParams}
        setTableParams={setTableParams}
        setFilterOptions={setFilterOptions}
      />
    </ContentWrapper>
  );
};

export default ActivationView;
